import {
  CHANGE_LOCAL_LOADING,
  CHANGE_PAGE_LOADING,
  CHANGE_ONBOARDING,
  CHANGE_ERR,
  CHANGE_SUCCESS,
  CHANGE_UPLOAD,
  CHANGE_DOWNLOAD,
  CHANGE_CITIES,
  CHANGE_COMPANIES,
  CHANGE_CATEGORIES,
  CHANGE_CLASSIFIERS
} from './actions'

export default function(state = {
  localLoading: false,
  pageLoading: false,
  onboarding: {
    visible: false,
    step: 0,
    question: '',
    text: '',
    to: '',
    left: 0,
    right: 0
  },
  err: '',
  success: '',
  upload: {
    spCaseId: '',
    progress: 0,
    total: 1,
    err: false
  },
  download: {
    spCaseId: '',
    fileRequest: '',
    fileId: '',
    progress: 0,
    total: 1,
    err: false
  },
  cities: [],
  companies: [],
  categories: []
}, action) {
  switch(action.type) {
    case CHANGE_LOCAL_LOADING:
      return { ...state, localLoading: action.payload }
    case CHANGE_PAGE_LOADING:
      return { ...state, pageLoading: action.payload }
    case CHANGE_ONBOARDING:
      return { ...state, onboarding: action.payload }
    case CHANGE_ERR:
      return { ...state, err: action.payload }
    case CHANGE_SUCCESS:
      return { ...state, success: action.payload }
    case CHANGE_UPLOAD:
      return { ...state, upload: action.payload }
    case CHANGE_DOWNLOAD:
      return { ...state, download: action.payload }
    case CHANGE_CITIES:
      return { ...state, cities: action.payload }
    case CHANGE_COMPANIES:
      return { ...state, companies: action.payload }
    case CHANGE_CATEGORIES:
      return { ...state, categories: action.payload }
    default:
      return state
  }
}
